<template>
	<div>
		<billing-plan-cancellation-pending-message v-if="subscription.status === 1" class="mb-4"/>

		<h2>
			Current Subscription
			<v-chip :color="status.color" outline> {{ status.title }} </v-chip>
		</h2>
		<p v-if="subscription.status === 0">Plan active since {{ startDateLocal }}</p>
		<div class="product-details-container">
			<product-plan-details :product-plan="productPlanDetails" hide-select />
		</div>

		<div class="mt-3" v-if="subscription.status === 0"><a href="#" @click.prevent="showDeactivateCompanyAccountDialog = true">Deactivate company account</a></div>
		<deactivate-company-account-dialog v-if="showDeactivateCompanyAccountDialog" :dialog="showDeactivateCompanyAccountDialog" @close="showDeactivateCompanyAccountDialog = false" />
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import productPlanStatus from '@/enums/productPlanStatus';
	import ProductPlanDetails from '@components/settings/billing/ProductPlanDetails.vue';
	import DeactivateCompanyAccountDialog from '@components/settings/billing/DeactivateCompanyAccountDialog.vue';
	import BillingPlanCancellationPendingMessage from '@/components/settings/billing/BillingPlanCancellationPendingMessage';

	export default {
		components: { ProductPlanDetails, DeactivateCompanyAccountDialog, BillingPlanCancellationPendingMessage },
		props: {
			subscription: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				showDeactivateCompanyAccountDialog: false
			};
		},
		computed: {
			...mapGetters({
				productPlans: 'productPlans/productPlans'
			}),
			productPlanDetails() {
				return this.productPlans.find(x => x.id === this.subscription.productPlanId);
			},
			status() {
				switch (this.subscription.status) {
					case productPlanStatus.Active:
						return { title: 'Active', color: 'success' };
					case productPlanStatus.CancelledPending:
						return { title: 'Cancellation Pending', color: 'warning' };
					case productPlanStatus.Cancelled:
						return { title: 'Cancelled', color: 'error' };
				}
			},
			startDateLocal() {
				const date = new Date(Date.parse(this.subscription.startDateUtc));
				return date.toLocaleDateString('en-AU');
			},
			endDateLocal() {
				const date = new Date(Date.parse(this.subscription.endDateUtc));
				return date.toLocaleDateString('en-AU');
			}
		}
	};
</script>

<style scoped>
	.product-details-container {
		display: flex;
		justify-content: center;
		align-items: center;
		max-width: 600px;
		width: 100%;
		margin: 0 auto;
	}
</style>
